import PropTypes from 'prop-types';
import { ButtonGroup, ToggleButton, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Languages from '../../../../enums/languages';

const LanguageToggleSwitch = ({
  name,
  selectedValue,
  onChange,
  buttonGroupClass,
  buttonClass
}) => {
  const toggleOptions = [
    { tooltip: 'English', value: Languages.English, icon: 'EN' },
    { tooltip: 'Spanish', value: Languages.Spanish, icon: 'ES' }
  ];

  return (
    <ButtonGroup className={`pt-1 z-index10 bg-white ${buttonGroupClass}`}>
      {toggleOptions.map((option, index) => (
        <>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip className="custom-tooltip">{option.tooltip}</Tooltip>
            }>
            <ToggleButton
              className={`btn-outline-castleRed align-content-center h-35 ${buttonClass}`}
              key={`${name}-language-toggle-${index}`}
              id={`${name}-language-toggle-${index}`}
              type="radio"
              variant=''
              name={`${name}-toggle-btn`}
              value={option.value}
              checked={selectedValue == option.value}
              onChange={(e)=> onChange(e.target.value)}
            >
              {option.icon}
            </ToggleButton>
          </OverlayTrigger>
        </>            
      ))}
    </ButtonGroup>
  );
};

LanguageToggleSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  selectedValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  buttonGroupClass: PropTypes.string,
  buttonClass: PropTypes.string
};

export default LanguageToggleSwitch;